// 可填写内容验证
/* eslint-disable */
export const regInvalids = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|[\uD800-\uDBFF][\uDC00-\uDFFF]|\u3030/ig;
export const dateReg = /^\d{4}-\d{2}-\d{2}/;



// WEBPACK FOOTER //
// ./src/regs/application-regs.js